<template>
  <v-container fluid class="device-list-layout-component-wrapper">
    <v-layout wrap>
      <v-flex>
        <slot name="page-header" />
        <v-row no-gutters>
          <v-col>
            <slot name="devices-list-searchbar" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <slot name="devices-list-toolbar" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="devices-list-layout-wrapper">
            <slot name="devices-list" />
          </v-col>
        </v-row>
        <v-row
          no-gutters
          :class="isActionBarOpen
            ? 'action-bar-wrapper'
            : 'action-bar-wrapper hidden'
          "
        >
          <v-col>
            <slot name="devices-list-action-bar" />
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import './styles/devices-list-layout.scss';

@Component
export default class DevicesListLayout extends Vue {
  @Prop({
    type: Boolean
  })
  private isActionBarOpen!: boolean;
}
</script>
